import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	receiveCardContainer: {
		padding: theme.spacing(0, 0.5),
		marginTop: theme.spacing(0.5),
	},
	receiveCard: {
		margin: theme.spacing(1, 0),
	},
	failureLabel: {
		height: "70px",
		marginRight: "10px",
		marginBottom: "10px",
		width: "100%",
	},
	label: {
		display: "flex",
		flexDirection: "row",
	},
	purchaseOrderNumber: {
		paddingLeft: theme.spacing(1),
	},
	disabled: {
		backgroundColor: theme.palette.error.dark,
	},
	note: {
		marginTop: "10px",
		marginBottom: "10px",
		fontWeight: 500,
		fontStyle: "italic",
	},
	statusTitle: {
		fontSize: "1.3rem",
	},
	creditRequestRootContainer: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
	},
	creditRequestListItem: {
		padding: theme.spacing(1, 2),
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(0.5, 1),
		},
	},
}));
